import React from "react";
import styled from "styled-components";

import { translations } from "../../../utils/translations.js";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Wrapper = styled.div`
  padding: 2rem;
`;

const PageTitle = styled.h1`
  color: var(--secondary-font-color);
  text-align: center;
  font-family: Georgia, serif;
  letter-spacing: 1px;
  padding-bottom: 2rem;
`;

const SubTitle = styled.h3`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  width: 100%;
`;

const Text = styled.p`
  color: var(--secondary-font-color);
  text-align: justify;
  font-family: Verdana, sans-serif;
`;

const List = styled.ul`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
`;

const TextSection = styled.div`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
`;

const Steps = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

const StepContainer = styled.div`
  background-color: var(--background-yellow);
  font-family: Verdana, sans-serif;
  border-radius: 30px 0 0 30px;
  width: 80%;
  display: flex;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StepNumber = styled.div`
  background-color: var(--fill-green);
  font-family: Verdana, sans-serif;
  width: 64px;
  height: 64px;
  border-radius: 50%;

  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  align-content: center;
  color: var(--background-yellow);

  @media (max-width: 768px) {
    width: 40px;
  height: 40px;
  font-size: 1.5rem;
  Î
`;

const StepContent = styled.p`
  font-family: Verdana, sans-serif;
  text-align: justify;
  text-wrap: wrap;
  font-size: 1rem;
  max-width: 80%;
  padding: 0 1rem;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  display: block;
  max-width: 30vw;

  @media (max-width: 768px) {
    max-width: 45vw;
  }
`;

const ImgComntainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const CustomProjectPage = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);
  if (languageCode === "ro")
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["custom-project-title"]}
        </PageTitle>

        <TextSection>
          <Text>
            Ai o idee nemaivăzută sau nu găsești piesele de care ai nevoie? Te
            putem ajuta să le transformi în realitate! Indiferent dacă ai nevoie
            de o piesă personalizată, un obiect unic sau doar design-ul pentru
            proiectul tău, suntem aici să îți oferim soluții rapide și
            eficiente.
            <List>
              <li>
                Flexibilitate totală: Personalizare completă, de la design la
                material.
              </li>
              <li>
                Eficiență și precizie: Creăm modele exacte, optimizate pentru
                nevoile tale.
              </li>
              <li>
                Rapiditate: De la idee la livrare, totul se desfășoară în cel
                mai scurt timp posibil.
              </li>
            </List>
            <Text>
              Și partea cea mai bună ? Poți alege și combina orice culori! Vezi{" "}
              <Link to="/colors">
                <b>aici</b>
              </Link>{" "}
              gama completă de culori disponibile.
            </Text>
            <Text>
              Ne poți contacta telefonic sau prin email și îți vom da toate
              detaliile de care ai nevoie pentru a începe proiectul tău
              personalizat.
            </Text>
          </Text>
        </TextSection>

        <TextSection>
          <SubTitle>
            Pașii pe care îi urmăm în realizarea proiectului tău
          </SubTitle>
          <Steps>
            <StepContainer>
              <StepNumber>1</StepNumber>
              <StepContent>
                Discutăm despre ideea ta. Alegem împreună materialele,
                dimensiunile și designul potrivit.
              </StepContent>
            </StepContainer>

            <StepContainer>
              <StepNumber>2</StepNumber>
              <StepContent>
                Pe baza specificațiilor tale, realizăm o schiță tehnică
                detaliată, la scară.
              </StepContent>
            </StepContainer>

            <Img src={"/images/step1.png"} alt="step1" />

            <StepContainer>
              <StepNumber>3</StepNumber>
              <StepContent>
                Transformăm schița într-un model 3D realist și realizăm toate
                verificările necesare pentru a asigura calitatea produsului.
              </StepContent>
            </StepContainer>

            <ImgComntainer>
              <Img src={"/images/step2.png"} alt="step1" />
              <Img src={"/images/step3.png"} alt="step1" />
            </ImgComntainer>

            <StepContainer>
              <StepNumber>4</StepNumber>
              <StepContent>
                Printăm 3D modelul cu ajutorul imprimantelor noastre
                profesionale, din materialul ales de tine.
              </StepContent>
            </StepContainer>

            <Img src={"/images/step4.png"} alt="step1" />

            <StepContainer>
              <StepNumber>5</StepNumber>
              <StepContent>
                După finalizare, produsul este ambalat cu grijă și livrat direct
                la tine acasă.
              </StepContent>
            </StepContainer>
          </Steps>
        </TextSection>
      </Wrapper>
    );
  else
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["custom-project-title"]}
        </PageTitle>

        <TextSection>
          <Text>
            Do you have a unique idea or can't find the parts you need? We can
            help you bring it to life! Whether you need a customized piece, a
            unique object, or just the design for your project, we are here to
            provide quick and efficient solutions.
            <List>
              <li>
                Complete flexibility: Full customization, from design to
                material.
              </li>
              <li>
                Efficiency and precision: We create exact models optimized for
                your needs.
              </li>
              <li>
                Speed: From idea to delivery, everything happens in the shortest
                possible time.
              </li>
            </List>
            <Text>
              And the best part? You can mix and match any color! See{" "}
              <Link to="/colors">
                <b>here</b>
              </Link>{" "}
              the full range of available colors.
            </Text>
            <Text>
              You can contact us by phone or email and we will give you all the
              details you need to start your custom project.
            </Text>
          </Text>
        </TextSection>

        <TextSection>
          <SubTitle>The steps we follow to create your project</SubTitle>
          <Steps>
            <StepContainer>
              <StepNumber>1</StepNumber>
              <StepContent>
                We discuss your idea. Together, we choose the right materials,
                dimensions, and design.
              </StepContent>
            </StepContainer>

            <StepContainer>
              <StepNumber>2</StepNumber>
              <StepContent>
                Based on your specifications, we create a detailed technical
                sketch to scale.
              </StepContent>
            </StepContainer>

            <Img src={"/images/step1.png"} alt="step1" />

            <StepContainer>
              <StepNumber>3</StepNumber>
              <StepContent>
                We transform the sketch into a realistic 3D model and perform
                all necessary checks to ensure the product’s quality.
              </StepContent>
            </StepContainer>

            <ImgComntainer>
              <Img src={"/images/step2.png"} alt="step2" />
              <Img src={"/images/step3.png"} alt="step3" />
            </ImgComntainer>

            <StepContainer>
              <StepNumber>4</StepNumber>
              <StepContent>
                We 3D print the model using our professional printers, in the
                material of your choice.
              </StepContent>
            </StepContainer>

            <Img src={"/images/step4.png"} alt="step4" />

            <StepContainer>
              <StepNumber>5</StepNumber>
              <StepContent>
                Once completed, the product is carefully packaged and delivered
                directly to your home.
              </StepContent>
            </StepContainer>
          </Steps>
        </TextSection>
      </Wrapper>
    );
};

export default CustomProjectPage;
